import { render } from "./LieveTandarts.vue?vue&type=template&id=6c9b1f36&scoped=true"
import script from "./LieveTandarts.vue?vue&type=script&lang=js"
export * from "./LieveTandarts.vue?vue&type=script&lang=js"

import "./LieveTandarts.vue?vue&type=style&index=0&id=6c9b1f36&scoped=true&lang=css"

import exportComponent from "/Users/alialsaady/Documents/repos/tandzorggestel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c9b1f36"]])

export default __exports__